/** 默认列宽（COLUMN_WIDTH_MAP 未命中时的回退值） */
export const DEFAULT_COL_WIDTH = 196;

/** EpisodeLayout 顶部 header 高 */
export const EPISODE_HEADER_HEIGHT = 60;

/** 镜号列宽度 */
export const SHOT_NO_COL_WIDTH = 60;

/** 操作列宽度 */
export const ACTION_COL_WIDTH = 60;

// ─── 列宽映射 ──────────────────────────────────────────────

/** key → width 映射 */
export const COLUMN_WIDTH_MAP: Record<string, number> = {
    shotNumber: SHOT_NO_COL_WIDTH,
    duration: 88,
    sceneType: DEFAULT_COL_WIDTH,
    sceneDesc: 460,
    characterAction: DEFAULT_COL_WIDTH,
    lightAtmosphere: DEFAULT_COL_WIDTH,
    sound: DEFAULT_COL_WIDTH,
    imagePrompt: 360,
    videoPrompt: 360,
    dialogue: DEFAULT_COL_WIDTH,
    refImage: 184,
    refVideo: 184,
};

// ─── 参考素材列 key → 类型映射 ──────────────────────────────

/** 使用 RefMediaCell 渲染的列 */
export const REF_MEDIA_KEYS: Partial<Record<string, 'image' | 'video'>> = {
    refImage: 'image',
    refVideo: 'video',
};

/** 使用 AudioCell 渲染的列 */
export const REF_AUDIO_KEYS = new Set(['audio']);

// ─── 分镜素材列 key → 类型映射 ──────────────────────────────

/** 使用 StoryboardMediaCell 渲染的列 */
export const STORYBOARD_MEDIA_KEYS: Partial<Record<string, 'image' | 'video'>> = {
    imageMaterials: 'image',
    videoMaterials: 'video',
};

// ─── 可编辑文本列 key 集合 ─────────────────────────────────

/** 使用 EditableCell 渲染的列 */
export const EDITABLE_KEYS = new Set([
    'sceneType',
    'sceneDesc',
    'characterAction',
    'lightAtmosphere',
    'imagePrompt',
    'videoPrompt',
    'sound',
]);

// ─── 表头文字居左的列 key 集合 ─────────────────────────────

/** 表头文字居左展示的文字列（其余列表头仍居中） */
export const LEFT_HEADER_KEYS = new Set([
    'sceneType',
    'sceneDesc',
    'dialogue',
    'characterAction',
    'lightAtmosphere',
    'sound',
    'imagePrompt',
    'videoPrompt',
]);
